import { createRpcClientV2 } from 'rpc-client-utils';
import { updateTaskStatusRpc, getFlowWithTasksRpc, createAssetRpc } from '../../__generated__/chirp/com/hubspot/marketing/discovery/rpc/MarketingDiscoveryService';
import http from 'hub-http/clients/apiClient';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const createAsset = async (groupKey, firstTask, assetType, properties) => {
  const response = await rpcClient.call(createAssetRpc, {
    request: {
      groupKey,
      firstTask,
      assetType,
      properties
    }
  });
  return response;
};
export const updateTaskStatus = async (groupKey, assetType, status) => {
  const response = await rpcClient.call(updateTaskStatusRpc, {
    request: {
      groupKey,
      assetType,
      status
    }
  });
  return response;
};
export const getFlowWithTasks = async groupKey => {
  const response = await rpcClient.call(getFlowWithTasksRpc, {
    request: {
      groupKey
    }
  });
  return response;
};